import { ActionCreator } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AxiosResponse } from 'axios'
import { toastMsg } from '../../../components/Toast/toastMsg'
import { IPagination } from '../../../types/pagination'
import { IProject } from '../../project/types/project'
import { ReportsState } from '../reducers'
import { ReportsApi } from './../../../api/reportsApi'
import { IDataLoader, IDepartmentUtilizationFilterData, IFTEByProject, IGlobalReportDepartmentUtilizationData, IGlobalReportExpectedPaymentsData, IGlobalReportExpenditurePhasingData, IGlobalReportHoursPhasingData, IProjectHoursPhasingFilterData, IProjectList, IProjectListFilterData, IReport, IReportChart, IReportFilter, ITasksByProject, ITasksByProjectFilterData } from './../types/reports'
import * as constants from './constants'

export type ReportsThunkResult<R> = ThunkAction<Promise<R>, ReportsState, null, ReportsActions>
export type ReportsThunkDispatchType = ThunkDispatch<ReportsState, null, ReportsActions>

export interface GetReportsErrored {
  type: constants.REPORTS_HAS_ERRORED
  hasErrord: boolean
}

export interface GetReportsSuccess {
  type: constants.GET_REPORTS_SUCCESS
  reports: IReport[]
}

export interface SetReportsFilter {
  type: constants.SET_REPORTS_FILTER
  report: IReportFilter
}

export interface GetTasksByProjectFilterSuccess {
  type: constants.GET_TASKS_BY_PROJECT_FILTER_SUCCESS
  data: ITasksByProjectFilterData
}

export interface SetLoader {
  type: constants.SET_LOADER
  load: boolean
}

export interface SetTasksByProjectSort {
  type: constants.SET_TASKS_BY_PROJECT_SORT
  sort: { name: string, direction: string }
}

export interface GetTasksByProjectFilterSuccess {
  type: constants.GET_TASKS_BY_PROJECT_FILTER_SUCCESS
  data: ITasksByProjectFilterData
}

export interface GetPaginatedTasksByProjectSuccess {
  type: constants.GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS
  data: IPagination<ITasksByProject[]>
}

export interface SetPaginationPageTasksByProject {
  type: constants.SET_PAGINATION_PAGE_TASKS_BY_PROJECT
  page: string
}

export interface SetLoader {
  type: constants.SET_LOADER
  load: boolean
}

export interface SetDataLoader {
  type: constants.SET_DATA_LOADER
  load: IDataLoader
}

export interface SetChartLoader {
  type: constants.SET_CHART_LOADER
  load: boolean
}

export interface SetTasksByProjectSort {
  type: constants.SET_TASKS_BY_PROJECT_SORT
  sort: { name: string, direction: string }
}

export interface GetProjectListFilterSuccess {
  type: constants.GET_PROJECT_LIST_FILTER_SUCCESS
  data: IProjectListFilterData
}

export interface GetProjectListSuccess {
  type: constants.GET_PROJECT_LIST_SUCCESS
  data: IPagination<IProject[]>
}

export interface SetPaginationPageProjectList {
  type: constants.SET_PAGINATION_PAGE_PROJECT_LIST
  page: string
}

export interface SetProjectListSort {
  type: constants.SET_PROJECT_LIST_SORT
  sort: { name: string, direction: string }
}

export interface GetFTEByProjectFilterSuccess {
  type: constants.GET_FTE_BY_PROJECT_FILTER_SUCCESS
  data: IProjectList
}

export interface GetFTEByProjectSuccess {
  type: constants.GET_FTE_BY_PROJECT_SUCCESS
  data: IFTEByProject
}

export interface SetPaginationPageFTEByProject {
  type: constants.SET_PAGINATION_PAGE_FTE_BY_PROJECT
  page: string
}

export interface SetFTEByProjectSort {
  type: constants.SET_FTE_BY_PROJECT_SORT
  sort: { name: string, direction: string }
}

export interface GetExpenditurePhasingSuccess {
  type: constants.GET_EXPENDITURE_PHASING_SUCCESS
  data: IGlobalReportExpenditurePhasingData
}

export interface SetPaginationPageExpenditurePhasing {
  type: constants.SET_PAGINATION_PAGE_EXPENDITURE_PHASING
  page: string
}

export interface SetExpenditurePhasingSort {
  type: constants.SET_EXPENDITURE_PHASING_SORT
  sort: { name: string, direction: string }
}

export interface SetExpenditurePhasingChartType {
  type: constants.SET_EXPENDITURE_PHASING_CHART_TYPE
  chart: { type: string, year: number }
}

export interface GetExpenditurePhasingChartSuccess {
  type: constants.GET_EXPENDITURE_PHASING_CHART_SUCCESS
  data: IReportChart
}

export interface GetDepartmentUtilizationFilterSuccess {
  type: constants.GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS
  data: IDepartmentUtilizationFilterData
}

export interface GetDepartmentUtilizationSuccess {
  type: constants.GET_DEPARTMENT_UTILIZATION_SUCCESS
  entries: IGlobalReportDepartmentUtilizationData
}

export interface SetPaginationPageDepartmentUtilization {
  type: constants.SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION
  page: string
}

export interface SetDepartmentUtilizationSort {
  type: constants.SET_DEPARTMENT_UTILIZATION_SORT
  sort: { name: string, direction: string }
}

export interface SetDepartmentUtilizationChartType {
  type: constants.SET_DEPARTMENT_UTILIZATION_CHART_TYPE
  chart: { type: string, year: number }
}

export interface GetDepartmentUtilizationChartSuccess {
  type: constants.GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS
  data: IReportChart
}

export interface GetProjectHoursPhasingFilterSuccess {
  type: constants.GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS
  data: IProjectHoursPhasingFilterData
}

export interface GetProjectHoursPhasingSuccess {
  type: constants.GET_PROJECT_HOURS_PHASING_SUCCESS
  entries: IGlobalReportHoursPhasingData
}

export interface SetPaginationPageProjectHoursPhasing {
  type: constants.SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING
  page: string
}

export interface SetProjectHoursPhasingSort {
  type: constants.SET_PROJECT_HOURS_PHASING_SORT
  sort: { name: string, direction: string }
}

export interface SetProjectHoursPhasingChartType {
  type: constants.SET_PROJECT_HOURS_PHASING_CHART_TYPE
  chart: { type: string, year: number }
}

export interface GetProjectHoursPhasingChartSuccess {
  type: constants.GET_PROJECT_HOURS_PHASING_CHART_SUCCESS
  data: IReportChart
}

export interface GetExpectedPaymentsFilterSuccess {
  type: constants.GET_EXPECTED_PAYMENTS_FILTER_SUCCESS
  data: IProjectList
}

export interface GetExpectedPaymentsSuccess {
  type: constants.GET_EXPECTED_PAYMENTS_SUCCESS
  data: IGlobalReportExpectedPaymentsData
}

export interface GetExpectedPaymentsChartSuccess {
  type: constants.GET_EXPECTED_PAYMENTS_CHART_SUCCESS
  data: IReportChart
}

export interface SetPaginationPageExpectedPayments {
  type: constants.SET_PAGINATION_PAGE_EXPECTED_PAYMENTS
  page: string
}

export interface SetExpectedPaymentsSort {
  type: constants.SET_EXPECTED_PAYMENTS_SORT
  sort: { name: string, direction: string }
}

export interface SetExpectedPaymentsChartType {
  type: constants.SET_EXPECTED_PAYMENTS_CHART_TYPE
  chart: { type: string, year: number }
}


export interface GetExpectedReceiptsFilterSuccess {
  type: constants.GET_EXPECTED_RECEIPTS_FILTER_SUCCESS
  data: IProjectList
}

export interface GetExpectedReceiptsSuccess {
  type: constants.GET_EXPECTED_RECEIPTS_SUCCESS
  data: IGlobalReportExpectedPaymentsData
}

export interface GetExpectedReceiptsChartSuccess {
  type: constants.GET_EXPECTED_RECEIPTS_CHART_SUCCESS
  data: IReportChart
}

export interface SetPaginationPageExpectedReceipts {
  type: constants.SET_PAGINATION_PAGE_EXPECTED_RECEIPTS
  page: string
}

export interface SetExpectedReceiptsSort {
  type: constants.SET_EXPECTED_RECEIPTS_SORT
  sort: { name: string, direction: string }
}

export interface SetExpectedReceiptsChartType {
  type: constants.SET_EXPECTED_RECEIPTS_CHART_TYPE
  chart: { type: string, year: number }
}

export interface SetFilterParams {
  type: constants.SET_FILTER_PARAMS
  params: Record<string, string>
}

export interface ClearReportsState {
  type: constants.CLEAR_REPORTS_STATE
}

export const getReportsHasErrored = (hasErrored: boolean, error: Error, action?: string): GetReportsErrored => {
  if (action) {
    const errorMsg = error.message
    toastMsg(errorMsg, action, 'error')
  }
  return {
    type: constants.REPORTS_HAS_ERRORED,
    hasErrord: hasErrored
  }
}

export const setLoader = (load: boolean): SetLoader => {
  return {
    type: constants.SET_LOADER,
    load
  }
}

export const setDataLoader = (load: IDataLoader): SetDataLoader => {
  return {
    type: constants.SET_DATA_LOADER,
    load
  }
}

/** Global Reports */
export const getReports: ActionCreator<ReportsThunkResult<IReport[]>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReport[]> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getReports(queryParams)
        .then(response => {
          dispatch(getReportsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_REPORTS))
          return [] as IReport[]
        })
    }
  }

export const getReportsSuccess = (reports: IReport[]): GetReportsSuccess => {
  return {
    type: constants.GET_REPORTS_SUCCESS,
    reports
  }
}

export const setReportsFilter = (report: IReportFilter): SetReportsFilter => {
  return {
    type: constants.SET_REPORTS_FILTER,
    report
  }
}

/** Task by Project */
export const getTasksByProjectFilter: ActionCreator<ReportsThunkResult<ITasksByProjectFilterData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<ITasksByProjectFilterData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getTasksByProjectFilterData(queryParams)
        .then(response => {
          dispatch(getTasksByProjectFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_TASKS_BY_PROJECT_FILTER))
          return {} as ITasksByProjectFilterData
        })
    }
  }

export const getTasksByProjectFilterSuccess = (data: ITasksByProjectFilterData): GetTasksByProjectFilterSuccess => {
  return {
    type: constants.GET_TASKS_BY_PROJECT_FILTER_SUCCESS,
    data
  }
}

export const getTasksByProject: ActionCreator<ReportsThunkResult<IPagination<ITasksByProject[]>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IPagination<ITasksByProject[]>> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getTasksByProject(queryParams)
        .then(response => {
          dispatch(getPaginatedTasksByProjectSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_TASKS_BY_PROJECT))
          return {} as IPagination<ITasksByProject[]>
        })
    }
  }

export const getPaginatedTasksByProjectSuccess = (data: IPagination<ITasksByProject[]>): GetPaginatedTasksByProjectSuccess => {
  return {
    type: constants.GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS,
    data
  }
}

export const setPaginationPageTasksByProject = (page: string): SetPaginationPageTasksByProject => {
  return {
    type: constants.SET_PAGINATION_PAGE_TASKS_BY_PROJECT,
    page
  }
}

export const setTasksByProjectSort = (sort: { name: string, direction: string }): SetTasksByProjectSort => {
  return {
    type: constants.SET_TASKS_BY_PROJECT_SORT,
    sort
  }
}

/** Project List */
export const getProjectListFilter: ActionCreator<ReportsThunkResult<IProjectListFilterData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IProjectListFilterData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getProjectListFilterData(queryParams)
        .then(response => {
          dispatch(getProjectListFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_PROJECT_LIST_FILTER))
          return {} as IProjectListFilterData
        })
    }
  }

export const getProjectListFilterSuccess = (data: IProjectListFilterData): GetProjectListFilterSuccess => {
  return {
    type: constants.GET_PROJECT_LIST_FILTER_SUCCESS,
    data
  }
}

export const getProjectList: ActionCreator<ReportsThunkResult<IPagination<IProject[]>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IPagination<IProject[]>> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getProjectList(queryParams)
        .then(response => {
          dispatch(getProjectListSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_PROJECT_LIST))
          return {} as IPagination<IProject[]>
        })
    }
  }

export const getProjectListSuccess = (data: IPagination<IProject[]>): GetProjectListSuccess => {
  return {
    type: constants.GET_PROJECT_LIST_SUCCESS,
    data
  }
}

export const setPaginationPageProjectList = (page: string): SetPaginationPageProjectList => {
  return {
    type: constants.SET_PAGINATION_PAGE_PROJECT_LIST,
    page
  }
}

export const setProjectListSort = (sort: { name: string, direction: string }): SetProjectListSort => {
  return {
    type: constants.SET_PROJECT_LIST_SORT,
    sort
  }
}

/** FTE by Project */
export const getFTEByProjectFilter: ActionCreator<ReportsThunkResult<IProjectList>>
  = (): ReportsThunkResult<IProjectList> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getFTEByProjectFilterData()
        .then(response => {
          dispatch(getFTEByProjectFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_FTE_BY_PROJECT_FILTER))
          return {} as IProjectList
        })
    }
  }

export const getFTEByProjectFilterSuccess = (data: IProjectList): GetFTEByProjectFilterSuccess => {
  return {
    type: constants.GET_FTE_BY_PROJECT_FILTER_SUCCESS,
    data
  }
}

export const getFTEByProject: ActionCreator<ReportsThunkResult<IFTEByProject>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IFTEByProject> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getFTEByProject(queryParams)
        .then(response => {
          dispatch(getFTEByProjectSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_FTE_BY_PROJECT))
          return {} as IFTEByProject
        })
    }
  }

export const getFTEByProjectSuccess = (data: IFTEByProject): GetFTEByProjectSuccess => {
  return {
    type: constants.GET_FTE_BY_PROJECT_SUCCESS,
    data
  }
}

export const setPaginationPageFTEByProject = (page: string): SetPaginationPageFTEByProject => {
  return {
    type: constants.SET_PAGINATION_PAGE_FTE_BY_PROJECT,
    page
  }
}

export const setFTEByProjectSort = (sort: { name: string, direction: string }): SetFTEByProjectSort => {
  return {
    type: constants.SET_FTE_BY_PROJECT_SORT,
    sort
  }
}

/** Expenditure Phasing */
export const getExpenditurePhasing: ActionCreator<ReportsThunkResult<IGlobalReportExpenditurePhasingData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IGlobalReportExpenditurePhasingData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpenditurePhasing(queryParams)
        .then(response => {
          dispatch(getExpenditurePhasingSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPENDITURE_PHASING))
          return {} as IGlobalReportExpenditurePhasingData
        })
    }
  }

export const getExpenditurePhasingSuccess = (data: IGlobalReportExpenditurePhasingData): GetExpenditurePhasingSuccess => {
  return {
    type: constants.GET_EXPENDITURE_PHASING_SUCCESS,
    data
  }
}

export const setPaginationPageExpenditurePhasing = (page: string): SetPaginationPageExpenditurePhasing => {
  return {
    type: constants.SET_PAGINATION_PAGE_EXPENDITURE_PHASING,
    page
  }
}

export const setExpenditurePhasingSort = (sort: { name: string, direction: string }): SetExpenditurePhasingSort => {
  return {
    type: constants.SET_EXPENDITURE_PHASING_SORT,
    sort
  }
}

export const setExpenditurePhasingChartType = (chart: { type: string, year: number }): SetExpenditurePhasingChartType => {
  return {
    type: constants.SET_EXPENDITURE_PHASING_CHART_TYPE,
    chart
  }
}

export const getExpenditurePhasingChart: ActionCreator<ReportsThunkResult<IReportChart>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReportChart> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpenditurePhasingChart(queryParams)
        .then(response => {
          dispatch(getExpenditurePhasingChartSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPENDITURE_PHASING_CHART))
          return {} as IReportChart
        })
    }
  }

export const getExpenditurePhasingChartSuccess = (data: IReportChart): GetExpenditurePhasingChartSuccess => {
  return {
    type: constants.GET_EXPENDITURE_PHASING_CHART_SUCCESS,
    data
  }
}

/** Department Utilization */
export const getDepartmentUtilizationFilter: ActionCreator<ReportsThunkResult<IDepartmentUtilizationFilterData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IDepartmentUtilizationFilterData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getDepartmentUtilizationFilterData(queryParams)
        .then(response => {
          dispatch(getDepartmentUtilizationFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_DEPARTMENT_UTILIZATION_FILTER))
          return {} as IDepartmentUtilizationFilterData
        })
    }
  }

export const getDepartmentUtilizationFilterSuccess = (data: IDepartmentUtilizationFilterData): GetDepartmentUtilizationFilterSuccess => {
  return {
    type: constants.GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS,
    data
  }
}

export const getDepartmentUtilization: ActionCreator<ReportsThunkResult<IGlobalReportDepartmentUtilizationData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IGlobalReportDepartmentUtilizationData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getDepartmentUtilization(queryParams)
        .then(response => {
          dispatch(getDepartmentUtilizationSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_DEPARTMENT_UTILIZATION))
          return {} as IGlobalReportDepartmentUtilizationData
        })
    }
  }

export const getDepartmentUtilizationSuccess = (entries: IGlobalReportDepartmentUtilizationData): GetDepartmentUtilizationSuccess => {
  return {
    type: constants.GET_DEPARTMENT_UTILIZATION_SUCCESS,
    entries
  }
}

export const setPaginationPageDepartmentUtilization = (page: string): SetPaginationPageDepartmentUtilization => {
  return {
    type: constants.SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION,
    page
  }
}

export const setDepartmentUtilizationSort = (sort: { name: string, direction: string }): SetDepartmentUtilizationSort => {
  return {
    type: constants.SET_DEPARTMENT_UTILIZATION_SORT,
    sort
  }
}

export const setDepartmentUtilizationChartType = (chart: { type: string, year: number }): SetDepartmentUtilizationChartType => {
  return {
    type: constants.SET_DEPARTMENT_UTILIZATION_CHART_TYPE,
    chart
  }
}

export const getDepartmentUtilizationChart: ActionCreator<ReportsThunkResult<IReportChart>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReportChart> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getDepartmentUtilizationChart(queryParams)
        .then(response => {
          dispatch(getDepartmentUtilizationChartSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_DEPARTMENT_UTILIZATION_CHART))
          return {} as IReportChart
        })
    }
  }

export const getDepartmentUtilizationChartSuccess = (data: IReportChart): GetDepartmentUtilizationChartSuccess => {
  return {
    type: constants.GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS,
    data
  }
}

/** Project Hours Phasing */
export const getProjectHoursPhasingFilter: ActionCreator<ReportsThunkResult<IProjectHoursPhasingFilterData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IProjectHoursPhasingFilterData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getProjectHoursPhasingFilterData(queryParams)
        .then(response => {
          dispatch(getProjectHoursPhasingFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_PROJECT_HOURS_PHASING_FILTER))
          return {} as IProjectHoursPhasingFilterData
        })
    }
  }

export const getProjectHoursPhasingFilterSuccess = (data: IProjectHoursPhasingFilterData): GetProjectHoursPhasingFilterSuccess => {
  return {
    type: constants.GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS,
    data
  }
}

export const getProjectHoursPhasing: ActionCreator<ReportsThunkResult<IGlobalReportHoursPhasingData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IGlobalReportHoursPhasingData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getProjectHoursPhasing(queryParams)
        .then(response => {
          dispatch(getProjectHoursPhasingSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_PROJECT_HOURS_PHASING))
          return {} as IGlobalReportHoursPhasingData
        })
    }
  }

export const getProjectHoursPhasingSuccess = (entries: IGlobalReportHoursPhasingData): GetProjectHoursPhasingSuccess => {
  return {
    type: constants.GET_PROJECT_HOURS_PHASING_SUCCESS,
    entries
  }
}

export const setPaginationPageProjectHoursPhasing = (page: string): SetPaginationPageProjectHoursPhasing => {
  return {
    type: constants.SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING,
    page
  }
}

export const setProjectHoursPhasingSort = (sort: { name: string, direction: string }): SetProjectHoursPhasingSort => {
  return {
    type: constants.SET_PROJECT_HOURS_PHASING_SORT,
    sort
  }
}

export const setProjectHoursPhasingChartType = (chart: { type: string, year: number }): SetProjectHoursPhasingChartType => {
  return {
    type: constants.SET_PROJECT_HOURS_PHASING_CHART_TYPE,
    chart
  }
}

export const getProjectHoursPhasingChart: ActionCreator<ReportsThunkResult<IReportChart>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReportChart> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getProjectHoursPhasingChart(queryParams)
        .then(response => {
          dispatch(getProjectHoursPhasingChartSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_PROJECT_HOURS_PHASING_CHART))
          return {} as IReportChart
        })
    }
  }

export const getProjectHoursPhasingChartSuccess = (data: IReportChart): GetProjectHoursPhasingChartSuccess => {
  return {
    type: constants.GET_PROJECT_HOURS_PHASING_CHART_SUCCESS,
    data
  }
}

/** Expected Payments */
export const getExpectedPaymentsFilter: ActionCreator<ReportsThunkResult<IProjectList>>
  = (): ReportsThunkResult<IProjectList> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedPaymentsFilterData()
        .then(response => {
          dispatch(getExpectedPaymentsFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_PAYMENTS_FILTER))
          return {} as IProjectList
        })
    }
  }

export const getExpectedPaymentsFilterSuccess = (data: IProjectList): GetExpectedPaymentsFilterSuccess => {
  return {
    type: constants.GET_EXPECTED_PAYMENTS_FILTER_SUCCESS,
    data
  }
}

export const getExpectedPayments: ActionCreator<ReportsThunkResult<IGlobalReportExpectedPaymentsData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IGlobalReportExpectedPaymentsData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedPayments(queryParams)
        .then(response => {
          dispatch(getExpectedPaymentsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_PAYMENTS))
          return {} as IGlobalReportExpectedPaymentsData
        })
    }
  }

export const getExpectedPaymentsSuccess = (data: IGlobalReportExpectedPaymentsData): GetExpectedPaymentsSuccess => {
  return {
    type: constants.GET_EXPECTED_PAYMENTS_SUCCESS,
    data
  }
}

export const setPaginationPageExpectedPayments = (page: string): SetPaginationPageExpectedPayments => {
  return {
    type: constants.SET_PAGINATION_PAGE_EXPECTED_PAYMENTS,
    page
  }
}

export const setExpectedPaymentsSort = (sort: { name: string, direction: string }): SetExpectedPaymentsSort => {
  return {
    type: constants.SET_EXPECTED_PAYMENTS_SORT,
    sort
  }
}

export const setExpectedPaymentsChartType = (chart: { type: string, year: number }): SetExpectedPaymentsChartType => {
  return {
    type: constants.SET_EXPECTED_PAYMENTS_CHART_TYPE,
    chart
  }
}


export const getExpectedPaymentsChart: ActionCreator<ReportsThunkResult<IReportChart>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReportChart> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedPaymentsChart(queryParams)
        .then(response => {
          dispatch(getExpectedPaymentsChartSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_PAYMENTS_CHART))
          return {} as IReportChart
        })
    }
  }

export const getExpectedPaymentsChartSuccess = (data: IReportChart): GetExpectedPaymentsChartSuccess => {
  return {
    type: constants.GET_EXPECTED_PAYMENTS_CHART_SUCCESS,
    data
  }
}

/** Expected Receipts */
export const getExpectedReceiptsFilter: ActionCreator<ReportsThunkResult<IProjectList>>
  = (): ReportsThunkResult<IProjectList> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedReceiptsFilterData()
        .then(response => {
          dispatch(getExpectedReceiptsFilterSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_RECEIPTS_FILTER))
          return {} as IProjectList
        })
    }
  }

export const getExpectedReceiptsFilterSuccess = (data: IProjectList): GetExpectedReceiptsFilterSuccess => {
  return {
    type: constants.GET_EXPECTED_RECEIPTS_FILTER_SUCCESS,
    data
  }
}

export const getExpectedReceipts: ActionCreator<ReportsThunkResult<IGlobalReportExpectedPaymentsData>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IGlobalReportExpectedPaymentsData> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedReceipts(queryParams)
        .then(response => {
          dispatch(getExpectedReceiptsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_RECEIPTS))
          return {} as IGlobalReportExpectedPaymentsData
        })
    }
  }

export const getExpectedReceiptsSuccess = (data: IGlobalReportExpectedPaymentsData): GetExpectedReceiptsSuccess => {
  return {
    type: constants.GET_EXPECTED_RECEIPTS_SUCCESS,
    data
  }
}

export const setPaginationPageExpectedReceipts = (page: string): SetPaginationPageExpectedReceipts => {
  return {
    type: constants.SET_PAGINATION_PAGE_EXPECTED_RECEIPTS,
    page
  }
}

export const setExpectedReceiptsSort = (sort: { name: string, direction: string }): SetExpectedReceiptsSort => {
  return {
    type: constants.SET_EXPECTED_RECEIPTS_SORT,
    sort
  }
}

export const getExpectedReceiptsChart: ActionCreator<ReportsThunkResult<IReportChart>>
  = (queryParams: Record<string, string>): ReportsThunkResult<IReportChart> => {
    return async (dispatch: ReportsThunkDispatchType) => {
      return ReportsApi.getExpectedReceiptsChart(queryParams)
        .then(response => {
          dispatch(getExpectedReceiptsChartSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(getReportsHasErrored(true, error.response.data, constants.GET_EXPECTED_RECEIPTS_CHART))
          return {} as IReportChart
        })
    }
  }

export const getExpectedReceiptsChartSuccess = (data: IReportChart): GetExpectedReceiptsChartSuccess => {
  return {
    type: constants.GET_EXPECTED_RECEIPTS_CHART_SUCCESS,
    data
  }
}

export const setExpectedReceiptsChartType = (chart: { type: string, year: number }): SetExpectedReceiptsChartType => {
  return {
    type: constants.SET_EXPECTED_RECEIPTS_CHART_TYPE,
    chart
  }
}

export const setFilterParams = (params: Record<string, string>): SetFilterParams => {
  return {
    type: constants.SET_FILTER_PARAMS,
    params
  }
}

export const clearReportsState = (): ClearReportsState => {
  return {
    type: constants.CLEAR_REPORTS_STATE
  }
}

export const downloadTasksByProjectCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportTasksByProject(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const downloadFTEbyProjectCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportFTEbyProject(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const downloadExpenditurePhasingCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportExpenditurePhasing(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const exportProjectHoursPhasing: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportProjectHoursPhasing(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}


export const downloadProjectListCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportProjectList(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const downloadExpectedPaymentsCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportExpectedPayments(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const downloadExpectedReceiptsCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportExpectedReceipts(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export const exportDepartmentUtilizationCSV: ActionCreator<ReportsThunkResult<void | Blob | AxiosResponse<Blob>>>
  = (queryParams: Record<string, string>): ReportsThunkResult<void | Blob | AxiosResponse<Blob>> => {
  return async () => {
    return ReportsApi.exportDepartmentUtilization(queryParams).then((response) => {
      toastMsg("CSV successfully exported", "CSV EXPORT", 'success')
      return response
    }).catch((error: Error) => toastMsg(error.message, "CSV EXPORT", 'error'))
  }
}

export type ReportsActions
  = GetReportsErrored
  | GetReportsSuccess
  | SetReportsFilter
  | GetTasksByProjectFilterSuccess
  | GetPaginatedTasksByProjectSuccess
  | SetLoader
  | SetTasksByProjectSort
  | GetProjectListFilterSuccess
  | GetProjectListSuccess
  | SetProjectListSort
  | GetFTEByProjectFilterSuccess
  | GetFTEByProjectSuccess
  | SetFTEByProjectSort
  | GetExpenditurePhasingSuccess
  | SetExpenditurePhasingSort
  | SetExpenditurePhasingChartType
  | GetExpenditurePhasingChartSuccess
  | GetDepartmentUtilizationFilterSuccess
  | GetDepartmentUtilizationSuccess
  | SetDepartmentUtilizationSort
  | SetDepartmentUtilizationChartType
  | GetDepartmentUtilizationChartSuccess
  | GetProjectHoursPhasingFilterSuccess
  | GetProjectHoursPhasingSuccess
  | SetProjectHoursPhasingSort
  | SetProjectHoursPhasingChartType
  | GetProjectHoursPhasingChartSuccess
  | GetExpectedPaymentsFilterSuccess
  | GetExpectedPaymentsSuccess
  | GetExpectedPaymentsChartSuccess
  | SetExpectedPaymentsSort
  | SetExpectedPaymentsChartType
  | GetExpectedReceiptsFilterSuccess
  | GetExpectedReceiptsSuccess
  | SetExpectedReceiptsSort
  | GetExpectedReceiptsChartSuccess
  | SetExpectedReceiptsChartType
  | SetPaginationPageTasksByProject
  | SetPaginationPageExpenditurePhasing
  | SetPaginationPageFTEByProject
  | SetPaginationPageProjectList
  | SetPaginationPageDepartmentUtilization
  | SetPaginationPageProjectHoursPhasing
  | SetPaginationPageExpectedPayments
  | SetPaginationPageExpectedReceipts
  | SetDataLoader
  | ClearReportsState
  | SetFilterParams
